import React, { Component } from "react";
import Url from "app/shared/constants/Url";
import axios from "axios";
import LoginLeft from "./AuthLeft";
import LoginRight from "./AuthRight";
import FooterLink from "./FooterLink";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import OnBoardingLayout from "../../../layouts/mainLayout";
// import "assets/styles/_auth.scss";
const LinkList = [
  {
    name: "ECLIDE",
    link: "https://eclide.clideoffice.com",
    id: 101,
  },
  {
    name: "CLIDEAnalyser",
    link: "https://clideoffice.com",
    id: 202,
  },
  {
    name: "CLIDEG",
    link: "https://clideg.clideoffice.com",
    id: 303,
  },
];

export default class Auth extends Component {
  constructor(props) {
    super(props);
    this.authCss = null; // Initialize to null
    this.state = {
      contentData: {},
      logoUrl: "",
      companyName: "",
      companyTagLine: "",
      tagLine: {},
    };
  }
  componentDidMount = () => {
    this._getLogo();
    // this._getTagline();
  };

  _getLogo = async () => {
    const requestData = {
      status: 1,
      link: Url.clientURL,
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.compnayLogo,
        undefined,
        requestData
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState({
              logoUrl: response.data.data.logo,
              companyName: response.data.data.company_name,
              companyTagLine: response.data.data.tag_line,
            });
          }
        })
        .catch((error) => console.log(error));
    });
  };

  _getTagline = async () => {
    let { hostname, protocol } = window.location;
    const requestData = {
      status: 1,
      link: `${protocol}//${hostname}`,
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.tagLine,
        undefined,
        requestData
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState({ tagLine: response.data.data });
          }
        })
        .catch((error) => console.log(error));
    });
  };
  render() {
    return (
      
      <OnBoardingLayout content={this.state}>
        <LoginRight />
      </OnBoardingLayout>
    );
  }
}
